import React, { useState, useEffect } from "react";
import Chart from "../../../../../../../components/Charts";
import { BlurSpinner } from "../../../../../../../components/BlurSpinner";
import useFetcher from "../../../../../../../hooks/useFetcher";
import { fetchPcm } from "../../../../../../../services/reportingServices";

const Component = ({ filters }) => {
  const currentPage = 1;
  const itemsPerPage = 100;
  const sort = { sortBy: "date", sortDirection: "asc" };
  const [lines, setLines] = useState();

  // eslint-disable-next-line no-unused-vars
  const [data, isLoading, error, setData, fetchData] = useFetcher(fetchPcm, [
    {
      endDate: filters.endDate,
      startDate: filters.startDate,
      razonSocial: filters.cliente,
      page: currentPage,
      perpage: itemsPerPage,
      orderBy: sort.sortBy,
      orderType: sort.sortDirection,
    },
  ]);

  const formatMonthYear = (dateString) => {
    const [year, month] = dateString.split("-");
    return `${month}-${year}`;
  };

  useEffect(() => {
    if (!!data && data.pmcList) {
      const transformedData = [];

      // Condicion de Pago
      const condicionDePagoData = {
        id: "Condicion de Pago",
        data: data.pmcList.rows.map((entry) => ({
          x: formatMonthYear(entry.date),
          y: data.condicionDePago,
        })),
      };

      transformedData.push(condicionDePagoData);

      // PMC
      const pmcData = {
        id: "PMC",
        data: data.pmcList.rows.map((entry) => ({
          x: formatMonthYear(entry.date),
          y: entry.pmc,
        })),
      };

      transformedData.push(pmcData);
      setLines(transformedData);
    }
  }, [data]);

  // const data = [
  //   {
  //     id: "Line 1",
  //     data: [
  //       { x: "A", y: 50 },
  //       { x: "B", y: 150 },
  //       // Add more data points as needed
  //     ],
  //   },
  //   {
  //     id: "Line 2",
  //     data: [
  //       { x: "A", y: 100 },
  //       { x: "B", y: 100 },
  //       // Add more data points as needed
  //     ],
  //   },
  // ];

  return (
    <BlurSpinner isLoading={isLoading}>
      <div>
        <div id="scroll" style={{ width: "100%", height: "100%", overflowX: "auto" }}>
          {lines ? (
            <Chart.Line
              width={lines[0] && lines[0].data && lines[0].data.length ? 100 * lines[0].data.length : 0}
              data={lines}
              axisBottom={{
                legend: "Meses",
              }}
              axisLeft={{
                legend: "PMC",
              }}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </BlurSpinner>
  );
};

export default Component;
